import React from 'react';
import PropTypes from 'prop-types';
import {NotebookDrawer} from './NotebookDrawer';
import {SectionList, Menu} from './SectionList';
import {SectionHeader} from './SectionHeader';
import {Sections} from './Sections';
import {Content, ContentItems, Title, Footer} from './Content';
import {NOTEBOOK_SECTIONS} from '@learningblocks/exp-constants/lib/Utilities';
import {OptionsBlockWithRedux as OptionsBlock} from '../DesignSection/OptionsBlock';
import './style.scss';

export function Notebook(props) {
  const toNextSection = () => {
    props.goToSection(props.nextSection.value);
  };

  const sectionHeader = () =>
    React.createElement(SectionHeader, {
      toggleCollapse: props.toggleCollapse,
    });

  const contentTitle = () =>
    React.createElement(Title, {
      title: props.currentSection.title,
    });

  const contentItems = () =>
    React.createElement(ContentItems, {
      components: props.sectionComponents,
    });

  const contentFooter = () =>
    React.createElement(Footer, {
      toNextSection: toNextSection,
      lastSection: !props.nextSection.hasOwnProperty('value'),
    });

  const sectionList = () =>
    React.createElement(SectionList, {
      sections: props.sections,
      menu: React.createElement(Menu, {
        goToSection: props.goToSection,
      }),
    });

  const designSectionMenu = () =>
    React.createElement(Menu, {
      ...props.currentSection,
      goToFirstSection: toNextSection,
    });

  const optionsBlock = () => React.createElement(OptionsBlock);

  const renderForDesignSection = () => (
    <Sections>
      {sectionHeader()}
      {designSectionMenu()}
      {optionsBlock()}
    </Sections>
  );

  const renderForCommonSection = () => {
    return (
      <>
        <Content
          titleComponent={contentTitle()}
          contentsComponent={contentItems()}
          footerComponent={contentFooter()}
        />
        <Sections>
          {sectionHeader()}
          {sectionList()}
        </Sections>
      </>
    );
  };

  const renderContent = () => {
    if (props.currentSection.value === NOTEBOOK_SECTIONS.DESIGN) {
      return renderForDesignSection();
    } else {
      return renderForCommonSection();
    }
  };

  return (
    <NotebookDrawer
      showOverlay={props.showOverlay}
      visible={props.visible}
      toggleCollapse={props.toggleCollapse}>
      <div className='notebook'>{renderContent()}</div>
    </NotebookDrawer>
  );
}

Notebook.propTypes = {
  /**
   * The Sections list item with details for Currently Selected Section
   */
  currentSection: PropTypes.object.isRequired,
  /**
   * The Section list item with details for next Section
   */
  nextSection: PropTypes.object.isRequired,
  /**
   * Function invoked to collapse and expand Notebook
   */
  toggleCollapse: PropTypes.func.isRequired,
  /**
   * List of components to be dispalyed in contents section
   */
  sectionComponents: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * List of Notebook Sections
   */
  sections: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * Funciton to invoke when you want to open a new notbook section
   */
  goToSection: PropTypes.func.isRequired,
  /**
   * Boolean to specify if Notebook Drawer is visible
   */
  visible: PropTypes.bool.isRequired,
  /**
   * Boolean turn off/on the black overlay
   */
  showOverlay: PropTypes.bool.isRequired,
};

Notebook.defaultProps = {
  currentSection: {},
  nextSection: {},
  showOverlay: true,
};
